export default __webpack_public_path__ + "static/projectinbox-04705e6c1fe6267f55942276c1d93af6.png";